import { SystemMessage } from 'components/Dialogue';
import { BaseSysMsgProps } from './types';
import dayjs from 'lib/dayjs';
import { useTranslate } from '@tolgee/react';
import { memo } from 'react';

export const SysCloseConversationMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();
  const { sysCloseConversationContent } = raw;
  return sysCloseConversationContent ? (
    <SystemMessage>
      {dayjs(Number(sysCloseConversationContent.timestamp)).format('YYYY-MM-DD HH:mm')}
      {` [${sysCloseConversationContent.assistantName}] `}
      {t('close_conversation')}
    </SystemMessage>
  ) : null;
});
